import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

const CUSTOM_RELATIVE_TIME = {
  future: 'in %s',
  past: '%s ago',
  s: 'a few seconds',
  ss: '%ds',
  m: '1m',
  mm: '%dm',
  h: '1h',
  hh: '%dh',
  d: '1d',
  dd: '%dd',
  M: 'a month',
  MM: '%d months',
  y: 'a year',
  yy: '%d years',
};

@Pipe({
  name: 'momentToNow',
  standalone: false,
})
export class MomentToNowPipe implements PipeTransform {
  transform(value: string): string {
    moment.updateLocale('en', {
      relativeTime: CUSTOM_RELATIVE_TIME,
    });
    return moment(value).diff(moment(), 'days') < -30 ? '>30d' : moment(value).toNow(true);
  }
}
